<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>Liste des groupes</h1>
                <div class="pageOptions">
                    <btn text="Ajouter" ico="add" @click="addGroup"
                         v-if="$store.getters.hasPerm('group:add/edit')"></btn>
                </div>
            </div>
        </div>

        <div class="double" id="groups-edit">
            <div class="table-responsive mr-30" id="table-groups">
                <table>
                    <thead>
                        <tr>
                            <th class="sticky-off">
                                Libelle
                                <table-order name="label"></table-order>
                            </th>
                            <th class="sticky-off">
                                Options
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(group,key) in groups" @click="selectGroup(key)"
                            :class="{'active':currentGroupKey === key}">
                            <td>{{group.label}}</td>
                            <td class="tableOptions">
                                <div @click="editGroup(group.id)" v-if="$store.getters.hasPerm('group:add/edit')"
                                     title="Modifier l'utilisateur">
                                    <svg class="option">
                                        <use xlink:href="#icon-edit"></use>
                                    </svg>
                                </div>
                                <label class="switch" v-if="$store.getters.hasPerm('group:add/edit')"
                                       :title="(group.active == 0 ? 'Activer' : 'Désactiver') + ' le groupe' ">
                                    <input type="checkbox" @change="activeGroup(group, $event)"
                                           :checked="group.active == 1">
                                    <span class="slider"></span>
                                </label>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="table-responsive">
                <table>
                    <thead>
                        <tr>
                            <th class="sticky-off">
                                Libelle
                                <table-order name="label"></table-order>
                            </th>
                            <th class="sticky-off">
                                Options
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(permision,key) in permissions">
                            <td>{{permision.label}}</td>
                            <td class="tableOptions">
                                <label class="switch" v-if="$store.getters.hasPerm('group:add/edit')"
                                       :title="(permision.allow == 0 ? 'Activer' : 'Désactiver') + ' la permission' ">
                                    <input type="checkbox" @change="activePermission(permision, $event)"
                                           :checked="permision.allow == 1">
                                    <span class="slider"></span>
                                </label>
                            </td>
                        </tr>
                        <tr v-if="permissions.length <= 0">
                            <td colspan="5" style="text-align: center">Veuillez sélectionner un groupe</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import Btn from "@/components/Btn";
    import SearchBar from "@/components/SearchBar";
    import Pagination from "@/components/Pagination";
    import TableOrder from "@/components/TableOrder";
    import axios from 'axios';
    import tools from '../config.ts';
    import Loader from "@/components/Loader";

    export default {
        name: "Groups",
        components: {Loader, SearchBar, Btn, Pagination, TableOrder},
        data() {
            return {
                limit: 100,
                currentPage: 0,

                groups: [],
                permissions: [],
                permision_group: [],

                currentGroupKey: -1,

                locals: ["currentPage", "groups"],
            }
        },
        methods: {

            loadGroups() {
                axios.get(tools.api("groups"), tools.headerGET())
                    .then((response) => {
                        this.groups = response.data;

                        tools.loader(false);
                        tools.saveLocals("groups", this);
                    })
                    .catch((e) => {
                        tools.loader(false);
                    })
            },
            loadGroupPermissions() {

                axios.get(tools.api("permissions/group/"+this.groups[this.currentGroupKey].id), tools.headerGET())
                    .then((response) => {
                        this.permissions = response.data;
                    })
                    .catch((e) => {
                        tools.loader(false);
                    })
            },
            addGroup() {
                this.$router.push("group")
            },
            editGroup(groupId) {
                this.$router.push("group/" + groupId)
            },
            activeGroup(group, $event) {

                let active = $event.target.checked;

                axios.get(tools.api("group/" + group.id + "/toggle/" + (active ? "1" : "0")), tools.headerGET())
                    .then((response) => {
                        if (!tools.isSuccessResponse(response)) {
                            $event.target.checked = false;
                            return tools.popup("valid", {
                                title: "Erreur",
                                message: "Erreur lors de l'activation/désactivation du groupe '" + group.label + "'",
                            });
                        }

                        tools.saveLocals("users", this);
                    })
                    .catch((error) => {
                        $event.target.checked = false;
                        tools.popup("valid", {
                            title: "Erreur",
                            message: "Erreur lors de l'activation/désactivation du groupe '" + group.label + "'. <br/><br/>Détail de l'erreur : <br/>" + tools.parseError(error)
                        })
                    })
            },
            activePermission(permission, $event) {

                let active = $event.target.checked;
                let group = this.groups[this.currentGroupKey];

                axios.get(tools.api("group/" + group.id + "/permission/" + permission.id + "/allow/" + (active ? "1" : "0")), tools.headerGET())
                    .then((response) => {
                        if (!tools.isSuccessResponse(response)) {
                            $event.target.checked = false;
                            return tools.popup("valid", {
                                title: "Erreur",
                                message: "Erreur lors de l'activation/désactivation de la permission '" + group.label + "'",
                            });
                        }

                        tools.saveLocals("users", this);
                    })
                    .catch((error) => {
                        $event.target.checked = false;
                        tools.popup("valid", {
                            title: "Erreur",
                            message: "Erreur lors de l'activation/désactivation de la permission '" + permission.label + "'. <br/><br/>Détail de l'erreur : <br/>" + tools.parseError(error)
                        })
                    })
            },
            selectGroup(key) {
                this.currentGroupKey = key;
                this.loadGroupPermissions();
            },
            limitChange(limit) {
                this.limit = limit;
                this.currentPage = 0;

                tools.saveCookies("groups", this);
            },
            pageChange(page) {
                this.currentPage = page;

                tools.saveLocals("groups", this);
            },
            search(filter) {
                this.filter = filter;

                tools.saveLocals("groups", this);
            },
        },
        mounted() {

            if (!this.$store.getters.hasPerm('group:list')) {
                return this.$router.back();
            }

            tools.loader(true);
            this.$store.commit("onEditMode", false);

            tools.setLocals("groups", this);
            tools.setCookies("groups", this);

            this.loadGroups();
        }
    }
</script>